import LinkedIn from "@mui/icons-material/LinkedIn";
import { MentorCardElement } from "./Elements";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const MentorCard = ({
    selected,
    onCardClick,
    mentor,
    onWhatsappButtonClick,
}) => {
    const handleMentorCardClick = (event) => {
        onWhatsappButtonClick(mentor);
    };

    const handleLinkedInClick = () => {
        let a = document.createElement("a");
        a.target = "_blank";
        a.href = mentor.linkedin;
        a.click();
    };

    const handleWhatsappClick = () => {
        console.log(mentor);
        onWhatsappButtonClick(mentor);
    };

    return (
        <MentorCardElement.Card
            selected={selected}
            onClick={handleMentorCardClick}
        >
            {/* <Grow in={selected && mentor?.availability}> */}
            {/* <MentorCardElement.DateTopRight>
                    {mentor.availability}
                </MentorCardElement.DateTopRight> */}
            {/* </Grow> */}

            <MentorCardElement.Image
                selected={selected}
                src={mentor?.img_url_web || `/profile-empty.webp`}
            />
            <MentorCardElement.Body>
                <MentorCardElement.Title
                    fontFamily={"Outfit"}
                    selected={selected}
                >
                    {mentor.name}
                </MentorCardElement.Title>
                <MentorCardElement.Details fontFamily={"Outfit"}>
                    {mentor.name.toLowerCase().includes("anupam")
                        ? "Full-Time Global MBA"
                        : mentor.name.toLowerCase().includes("arvind")
                        ? "MS in Cybersecurity Engineering"
                        : mentor.name.toLowerCase().includes("kritika")
                        ?"MSc in Eco-Design"
                        : mentor.bio.split("\\n").map((text) => (
                              <>
                                  {text} <br />
                              </>
                          ))}
                </MentorCardElement.Details>
            </MentorCardElement.Body>
            <MentorCardElement.Action selected={selected}>
                <MentorCardElement.Button
                    id="linkedin-btn-collegeit"
                    iconcolor="#0077b5"
                    selected={!selected}
                    onClick={handleLinkedInClick}
                >
                    <LinkedIn />
                </MentorCardElement.Button>
                <MentorCardElement.Button
                    id="whatsapp-btn-collegeit"
                    iconcolor="#128C7E"
                    selected={!selected}
                    onClick={handleWhatsappClick}
                >
                    <WhatsAppIcon />
                </MentorCardElement.Button>
            </MentorCardElement.Action>
        </MentorCardElement.Card>
    );
};

export default MentorCard;
